import React from "react";
import { dispatch } from '@rematch/core';
import { Form, Dropdown, Checkbox } from 'formsy-semantic-ui-react';
import { Grid, Button, List, Loader, Card, Icon, Image } from "semantic-ui-react";
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import CreateInitiativeSteps from './Steps';
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import Labels from './../../../../common/Labels'
import LoadingComponent from "../../../../common/LoadingComponent";
import TextEditor from '../../../../common/TextEditor';
import { withRouter } from 'react-router-dom';
import { singleLineText } from "../../../../common/RegexValidation";
import defaultImage from './../../../../../images/common/practice-default.png';
import ImageResizer from './../../../../drive/ImageResizer/ImageResizer';
import noImage from '../../../../../images/common/broken-image.png'
import Tags from "../../../lifecycleDesigner/ResourcesPane/IndesignComponent/Tags"
import { slugify } from '../../../../../helpers/slugify';
var moment = require('moment');
const _ = require('lodash');

let authorObj;

class BasicInfo extends React.Component {
    constructor(props) {

        super(props);
        this.state = {
            level: 'workspace',
            teamId: null,
            isSequential: false,
            updatedImage: defaultImage,
            images: [],
            includeChecklist:false,
            isChecked: false
        }
        this.getTeam = this.getTeam.bind(this);
        this.validate = this.validate.bind(this);
        this.updateText = this.updateText.bind(this)
    }

    openImageModal = (open) => {
        this.setState({ open: open })
    }

    cloudinaryImage = (imageData) => {
        this.setState({ loader: true })
        if (imageData && imageData.data) {
            this.setState({ updatedImage: imageData.data.secure_url, loader: false })
            // dispatch.initiatives.updateInitiativeBySpecificFields({ _id: this.props.selectedDataById, picture: imageData.data.secure_url });
        }
    }

    componentDidMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        if (this.props.selectedDataById && this.props.selectedDataById.picture) {
            this.setState({ updatedImage: this.props.selectedDataById.picture });
        } else {
            this.handleChangeTileImage()
        }
        dispatch.initiatives.setTabName("BasicInfo");
    }

    handleChangeTileImage = () => {

        let randomImageNumber = Math.floor(Math.random() * 10) + 1
        let imgUrl = "https://res.cloudinary.com/" + this.props.envData.cloudName + "/image/upload/Cards/initiative/" + randomImageNumber + ".png";
        this.setState({ updatedImage: imgUrl })
    }

    handleOraginalImage = (e) => {
        if (e.target.checked) {
            this.setState({ isChecked: true })
            this.setState({ updatedImage: this.props.selectedPlaybookData.picture ? this.props.selectedPlaybookData.picture : this.props.selectedDataById.picture })
        }
        else {
            this.setState({ isChecked: false })
            this.handleChangeTileImage()
        }

    }

    async componentWillMount() {
        dispatch.initiatives.isInitiativeAvailable(false)
        // const history = this.props.history;
        let objValidation = Object.entries(this.props.selectedDataById).length === 0 && this.props.selectedDataById.constructor === Object

        if (this.props.match.params.initiativeId) {
            await dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        } else {
            dispatch.initiatives.NotFound(true)
            if (this.props.selectedPlaybookData && this.props.selectedPlaybookData.name) {
                let payload = {
                    name: this.props.selectedPlaybookData.name.trim(),
                    organizationId: this.props.selectedOrganisation.id
                }
                if (this.props && this.props.selectedInitiative && this.props.selectedInitiative._id) {
                    payload._id = this.props.selectedInitiative._id;
                }
                dispatch.initiatives.searchInitiativeByName(payload);
            }
        }

        if (this.props.selectedDataById.teamId && this.props.selectedDataById.teamId != this.props.selectedOrganisation.id) {
            this.setState({ 'level': 'team' })
        }
        if (this.props.selectedOrganisation.role == 'workspaceOwner') {
            this.setState({ 'teamId': this.props.selectedDataById.teamId ? this.props.selectedDataById.teamId : this.props.selectedOrganisation.id })
        }


        if (!this.props.teamList || this.props.teamList.length === 0) {
            let payload = {};
            payload.id = this.props.selectedOrganisation.id;
            payload.teamlist = true;
            dispatch.initiatives.getTeamsUnderManager(payload);
        }

        if (this.props.match.params.initiativeId) {
            this.setState({
                selectedData: this.props.selectedDataById,
                name: this.props.selectedDataById.name,
                description: this.props.selectedDataById.description
            })
        } else {
            this.setState({
                selectedData: this.props.selectedPlaybookData,
                name: this.props.selectedPlaybookData.name,
                description: this.props.selectedPlaybookData.description
            })
        }
        let timeZone = null;
        if (this.props.selectedOrganisation.timeZone) {
            timeZone = this.props.selectedOrganisation.timeZone;
        } else {
            timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const payload = {
                organizationId: this.props.selectedOrganisation.id,
                timeZone
            }
            dispatch.organizationUnit.updateOrgTimeZone(payload);
        }
        this.setState({ updatedImage: this.props.selectedDataById.picture ? this.props.selectedDataById.picture : defaultImage })

    }

    componentWillReceiveProps() {
        if (this.props.match.params.initiativeId) {
            // if (!this.state.description) {
            //     this.setState({ description: this.props.selectedDataById.description })
            // }
            this.setState({
                selectedData: this.props.selectedDataById,
                name: this.props.selectedDataById.name,
                description: this.props.selectedDataById.description
            })
        } else {
            // if (!this.state.description) {
            //     this.setState({ description: this.props.selectedPlaybookData.description })
            // }
            this.setState({
                selectedData: this.props.selectedPlaybookData,
                name: this.props.selectedPlaybookData.name,
                description: this.props.selectedPlaybookData.description
            })
        }
        if (_.isEmpty(this.props.selectedPlaybookData) && !this.props.match.params.initiativeId) {
            const history = this.props.history;
            history.push({
                pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/selectPlaybook'
                //pathname: '/app/' + this.props.selectedOrganisation.id + '/initiative/new/selectPlaybook'
            });
        }
    }

    handleChange = (data) => {
        let payload = {
            name: data.target.value.trim(),
            organizationId: this.props.selectedOrganisation.id,
            _id: this.props.selectedInitiative._id
        }
        dispatch.initiatives.searchInitiativeByName(payload);
        this.setState({ selectedDataName: data.target.value.trim() })
    }

    next = async () => {
        let payload = {
            name: this.state.selectedDataName ? this.state.selectedDataName : this.state.name,
            accountId: this.props.match.params.accountId,
            description: this.state.description,
            tags: this.state.tags,
            includeChecklist:this.state.includeChecklist,
            organizationId: this.props.selectedOrganisation.id,
            status: 0,
            slug: this.state.selectedDataName ? slugify(this.state.selectedDataName) : slugify(this.state.name),
            picture: this.props.match.params.initiativeId ? this.state.updatedImage : this.state.updatedImage,
            practiceId: this.props.match.params.initiativeId ? this.props.selectedDataById.practiceId : this.props.selectedPlaybookData._id,
            baseId: this.props.match.params.initiativeId ? this.props.selectedDataById.baseId : this.props.selectedPlaybookData.baseId,
            category: this.props.match.params.initiativeId ? this.props.selectedDataById.category : this.props.selectedPlaybookData.category,
            subCategory: this.props.match.params.initiativeId ? this.props.selectedDataById.subCategory : this.props.selectedPlaybookData.subCategory,
            baseCategory: this.props.match.params.initiativeId ? this.props.selectedDataById.baseCategory : this.props.selectedPlaybookData.baseCategory,
            createdBy: this.props.user._id,
            teamId: this.props.selectedDataById.teamId ? this.props.selectedDataById.teamId : this.state.teamId ? this.state.teamId : this.props.selectedOrganisation.id,
            isSequential: this.props.match.params.initiativeId ? this.props.selectedDataById.isSequential : this.state.isSequential,
            metaData: this.props.match.params.initiativeId ? this.props.selectedDataById.metaData : {}
        }

        if (!this.props.match.params.initiativeId) {
            payload.playbookDesigner = authorObj && authorObj[0] && authorObj[0].name
        }

        if (this.props.match.params.initiativeId) {
            delete payload.createdBy;
            payload._id = this.props.match.params.initiativeId;
            dispatch.initiatives.updateInitiativeBySpecificFields(payload);
            dispatch.initiatives.updateInitiativeList({ _id: payload._id, data: payload })
            const history = this.props.history;
            if (this.props.selectedDataById &&
                this.props.selectedDataById.practiceId &&
                this.props.selectedDataById.practiceId.metaDataSchema &&
                this.props.selectedDataById.practiceId.metaDataSchema.length !== 0) {
                history.push({
                    pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/addAdditionalInfo/' + this.props.match.params.initiativeId
                });
            } else {
                history.push({
                    pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/teamMapping/' + this.props.match.params.initiativeId
                });
            }

        } else {
            delete payload._id;

            let attchments = this.props.selectedPlaybookData && this.props.selectedPlaybookData.attachments ? this.props.selectedPlaybookData.attachments : [];
            for (let index = 0; index < attchments.length; index++) {
                attchments[index].uploadedBy = this.props.user && this.props.user._id;
                attchments[index].uploadedAt = moment();
                attchments[index].inherited = true;
            }
            payload.attachments = attchments;

            let timeZone = null;
            if (this.props.selectedOrganisation.timeZone) {
                timeZone = this.props.selectedOrganisation.timeZone;
            } else {
                timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const orgPayload = {
                    orgId: this.props.selectedOrganisation.id,
                    timeZone
                }
                dispatch.organizationUnit.updateOrgTimeZone(orgPayload);
            }

            payload.workingDays = [false, true, true, true, true, true, false];
            payload.timeZone = timeZone;
            payload.isMetaAvailable = this.props.selectedPlaybookData &&
                this.props.selectedPlaybookData.metaDataSchema &&
                this.props.selectedPlaybookData.metaDataSchema.length !== 0 ? true : false
            const value = await dispatch.initiatives.createInitiative(payload);
            // await dispatch.content.contentInitiativeService(this.props.selectedInitiative)
        }
    }

    handleCancel() {

        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in'
        });
    }

    async deleteInitiative() {
        let initId = this.props.match.params.initiativeId;
        let payload = await Object.assign({}, this.props.selectedDataById);
        payload.initId = initId;
        let message = <div className="confirmMessage">
            <h3>Delete Initiative</h3>
            <label>{this.props.selectedDataById.name}</label>
            <p>Are you sure that you wish to do this?</p>
            <span >This action is not reversible</span>
        </div>
        await toastr.confirm(message, {
            onOk: () => {
                dispatch.initiatives.removeInitiative(payload);
            }
        });
    }

    setExecutionLevel(e, data) {
        this.setState({ "level": data.value });
        this.setState({ 'teamId': null })
        this.validate();
    }

    handleTeam(values, data) {
        this.setState({ 'teamId': data.value })
        this.validate();
    }
    getTeam() {
        const teamObj = this.props.teamList && this.props.teamList.filter((team) => {
            return team.value === this.props.selectedDataById.teamId
        })
        return teamObj ? teamObj && teamObj[0] && teamObj[0].text : '';
    }

    validate() {
        if (this.state.level === 'team' && (!this.state.teamId || this.state.teamId === this.props.selectedOrganisation.id)) {
            this.setState({ 'isDisabled': true });
        }
        else {
            this.setState({ 'isDisabled': false });
        }
    }

    updateText(data, name) {
        if (name === "Description") {
            this.setState({ description: data })
        }
    }
    gotoOrg() {
        const history = this.props.history;
        history.push({
            pathname: '/app/workspace/community/listorg'
        });
    }
    setExecutionFlow(e, data) {
        this.setState({ isSequential: data.value })
    }

    createTeam(e) {
        const history = this.props.history;
        dispatch.organizationUnit.landingPageFlagSet(false);
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/createTeam/addTeamInitative/${this.props.selectedOrganisation.id}/${this.props.selectedOrganisation.id}`
        });
    }

    addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }

    onHandleTag = (tags) => {
        this.setState({ tags: tags })
        // let tagspayload = {
        //     id: this.props.selectedDataById._id,
        //     tags: tags
        // }
        // dispatch.initiatives.updateInitiative(tagspayload);

    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        let isNameAvailable = this.props.validateInitiativeName;
        if (isNameAvailable && this.props.match.params.initiativeId && this.props.selectedDataById && this.props.selectedDataById._id) {
            isNameAvailable = this.props.match.params.initiativeId.toString() === this.props.selectedDataById._id.toString() ? true : false;
        }
        let windowDimension = this.props.componentDesignerDimension;
        let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 50;
        authorObj = this.props.selectedPlaybookData && this.props.selectedPlaybookData.participants && this.props.selectedPlaybookData.participants.length ?
            this.props.selectedPlaybookData.participants.filter((participant, index) => {
                return participant.role === 'author'
            }) : '';
        return (
            <div className="w_100" ref={this.parentRef} style={{ width: "100%", minHeight: designerHeight ? designerHeight : 200, maxHeight: designerHeight ? designerHeight : 200, overflowY: "scroll" }}>

                <Grid className="containerBoxFullWidth">
                    {/* <LoadingComponent message="Loading Initiative..." active={this.props.teamList.length===0} /> */}
                    <LoadingComponent message="Loading Initiative details..." active={this.props.loadingDataById || this.props.teamList.length===0} />
                    <LoadingComponent message="Get ready to map roles with teams..." active={this.props.loadingcreateInitiative} />

                    <Grid.Row >
                        <BreadCrumbs {...this.props} />
                    </Grid.Row>
                    <Grid.Row >
                        <CreateInitiativeSteps {...this.props} setPage="basicInfo" />
                    </Grid.Row>

                    <Grid.Row  >
                        <Form
                            noValidate
                            className="addinitiativeForm formcyForm"
                            id='addinitiativeForm'
                        >
                            <Grid className="  basicInfo ">

                                <Grid.Row>
                                    <Grid.Column width={11}>
                                        <Form.Field>
                                            <Form.Input
                                                value={this.state.selectedData ? this.state.selectedData.name : this.state.name}
                                                onChange={this.handleChange}
                                                name='name'
                                                id='name'
                                                label='Name'
                                                required
                                                validations={{ matchRegexp: singleLineText }}
                                                validationErrors={{
                                                    matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                                    isDefaultRequiredValue: 'Name is required',
                                                }}
                                                errorLabel={errorLabel}
                                                instantValidation
                                                autoFocus
                                            />
                                            {isNameAvailable ?
                                                <span className="clr-red">
                                                    Initiative with same name already exists. Please rename the initiative.
                                                </span> : ""}
                                        </Form.Field>

                                        <TextEditor
                                            name="Description"
                                            text={this.state.description}
                                            type="textarea"
                                            onChangeText={this.updateText}
                                        />

                                        <div style={{display:"flex",alignItems:"center",height:"wrap-content"}}>
                                            <Checkbox
                                            toggle
                                            name={"label"}
                                            style={{ display: "inline-block", marginTop: "10px" }}
                                            onChange={() => this.setState((prevState) => ({ includeChecklist: !prevState.includeChecklist }))} />
                                            <span style={{ display: "inline-block",  marginLeft: "10px", marginBottom:"2px" }}>Do you want checklist in your activities?</span>
                                        </div>                               
                                        
                                        <Tags
                                            module="initiative"
                                            tags={this.props.selectedDataById.tags}
                                            onHandleTag={this.onHandleTag}
                                            editAccess={true}
                                        />


                                        {/* <Form.Field>
                                            {(this.props.selectedDataById.teamId && this.props.selectedDataById.teamId !== this.props.selectedOrganisation.id) ?
                                                <Labels name="Initiative Execution" text="Team Level" />
                                                :
                                                (this.props.selectedDataById.teamId && this.props.selectedDataById.teamId === this.props.selectedOrganisation.id) ?
                                                    <Labels name="Initiative Execution" text="Workspace Level" />
                                                    :
                                                    this.props.selectedOrganisation.role === 'workspaceOwner' ?
                                                        <Form.Group width={12} grouped style={{ 'marginTop': '8px' }}>
                                                            <strong>Initiative Execution </strong>
                                                            <Form.Group inline style={{ "marginTop": "12px" }}>
                                                                <Form.Radio
                                                                    name='workspace'
                                                                    label='Workspace Level'
                                                                    value='workspace'
                                                                    checked={this.state.level === 'workspace'}
                                                                    onChange={(event, data) => this.setExecutionLevel(event, data)}
                                                                />
                                                                <Form.Radio
                                                                    name='team'
                                                                    label='Team Level'
                                                                    value='team'
                                                                    checked={this.state.level === 'team'}
                                                                    onChange={(event, data) => this.setExecutionLevel(event, data)}
                                                                />
                                                            </Form.Group>
                                                        </Form.Group> : ''}
                                        </Form.Field> */}
                                        {/* Initiative Execution Level */}

                                        {this.props.teamList.length > 1 ? <span></span> : <span className="clr-red">
                                            To create the initiative, please add a team to your workspace first.
                                        </span>}

                                        {(this.state.level === 'workspace' && this.props.teamList.length === 1) ? 
                                            <List verticalAlign='middle' className="w_100 display-block pad_10" style={{
                                                borderRadius: "4px", border: "1px solid #D4B25E",
                                                color: "#D4B25E",
                                                background: "#FFF9DF"
                                            }}>
                                                <List.Item>
                                                    <List.Content floated='right'>
                                                        <Button onClick={(e) => this.createTeam(e)} className="button-submit" >Create Team</Button>
                                                    </List.Content>
                                                    <List.Content style={{ lineHeight: "32px" }}>No teams available.</List.Content>
                                                </List.Item>
                                            </List> : <div></div>
                                        }

                                        {/* {(this.state.level === 'team' && !this.props.selectedDataById.teamId) || (!this.props.selectedDataById.teamId && this.props.selectedOrganisation.role === 'Manager') ?

                                            this.props.teamList && this.props.teamList.length !== 1 ?
                                                <Form.Group width={12} grouped style={{ 'marginTop': '8px' }}>
                                                    <label>Search Team <span style={{ color: '#db2828' }}>*</span></label>
                                                    <Dropdown
                                                        name="singleSelectWithDefaultValue"
                                                        placeholder="Search Team"
                                                        search
                                                        selection
                                                        defaultValue={this.props.selectedDataById.teamId}
                                                        required
                                                        validationErrors={{
                                                            isDefaultRequiredValue: 'Team is required',
                                                        }}
                                                        errorLabel={errorLabel}
                                                        options={this.props.teamList}
                                                        onChange={(values, value) => { this.handleTeam(values, value) }}
                                                    />
                                                </Form.Group> :

                                                <List verticalAlign='middle' className="w_100 display-block pad_10" style={{
                                                    borderRadius: "4px", border: "1px solid #D4B25E",
                                                    color: "#D4B25E",
                                                    background: "#FFF9DF"
                                                }}>
                                                    <List.Item>
                                                        <List.Content floated='right'>
                                                            <Button onClick={(e) => this.createTeam(e)} className="button-submit" >Create Team</Button>
                                                        </List.Content>
                                                        <List.Content style={{ lineHeight: "32px" }}>No teams available.</List.Content>
                                                    </List.Item>
                                                </List>


                                            :
                                            this.props.selectedDataById.teamId && this.props.selectedDataById.teamId != this.props.selectedOrganisation.id ?
                                                <Labels
                                                    name="Selected Team "
                                                    text={this.getTeam()} />
                                                : ''
                                        } */}

                                    </Grid.Column>
                                    <Grid.Column width={5}>
                                        <label><b>Image</b></label>
                                        <div style={{ "paddingTop": "5px" }}>
                                            <Card className="organizationCard" >
                                                <Card.Content >
                                                    <div >
                                                        <Loader active={this.state.loader} />
                                                        <Image onError={this.addDefaultSrc} src={this.state.updatedImage} className="fitImage" />
                                                        <Button type="button" className="circular_24_icon second-rectangle-image" icon='refresh' disabled={this.state.isChecked} onClick={this.handleChangeTileImage} />
                                                        <Button type="button" className="circular_24_icon first-rectangle-image" icon='pencil' disabled={this.state.isChecked} onClick={() => this.openImageModal(true)} />
                                                    </div >
                                                </Card.Content>
                                            </Card>
                                            {this.props.match.params.initiativeId ? null :
                                                <div style={{ margin: "10px 0 0 0" }}>
                                                    <input
                                                        style={{ margin: '2px 0 0 0 !important', 'height': '18px' }}
                                                        type="checkbox"
                                                        onChange={this.handleOraginalImage}
                                                    />
                                                    <span style={{ 'font-size': '12px', 'margin-left': '5px' }}>Use image of selected playbook</span>
                                                </div>}
                                            <ImageResizer
                                                image={this.state.updatedImage}
                                                openImageModal={this.openImageModal}
                                                cloudinaryImage={this.cloudinaryImage}
                                                open={this.state.open}
                                                envData={this.props.envData}
                                                width={504}
                                                height={280}
                                            />
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width={8} className="pad_0">

                                    </Grid.Column >
                                    {this.props.match.params.initiativeId === undefined || this.props.selectedDataById.status === 0 ?
                                        <Grid.Column width={8} className="pad_0" >
                                            <div className="bottom_button_set actionInFormcy border-none" style={{ textAlign: "right" }} >

                                                <Button
                                                    type='submit'
                                                    id='next'
                                                    className="button-submit float-right"
                                                    onClick={this.next}
                                                    disabled={(isNameAvailable)}
                                                >
                                                    Next </Button>
                                                <Button
                                                    type='button'
                                                    id='Cancel'
                                                    className="button-cancel"
                                                    onClick={() => this.handleCancel()}

                                                >
                                                    Cancel </Button>
                                            </div>
                                        </Grid.Column > : ""
                                    }
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Grid.Row>
                </Grid>

            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        selectedActivityData: state.initiatives.selectedActivityData,
        selectedInitiative: state.initiatives.selectedDataById
    }
}
export default withRouter(connect(mapStateToProps)(BasicInfo));